// ABOUTME: Renders a job or attempt state as a coloured chip with its translated label, falling back
// ABOUTME: to the raw value. Used by the job list, the job detail and the schedules list.

import { Chip, ChipProps } from '@ds/coolshop';

import { useAttemptStateLabel, useJobStateLabel } from '../registry';

const STATE_COLORS: Record<string, ChipProps['color']> = {
    queued: 'default',
    pending: 'default',
    running: 'primary',
    retrying: 'warning',
    succeeded: 'success',
    failed: 'error',
    timedOut: 'error',
    cancelled: 'warning',
    skipped: 'default',
};

export function JobStateLabel(props: Readonly<{ state: string; attempt?: boolean }>) {
    const { state, attempt } = props;
    const jobStateLabel = useJobStateLabel();
    const attemptStateLabel = useAttemptStateLabel();
    return (
        <Chip
            size="small"
            color={STATE_COLORS[state] ?? 'default'}
            label={attempt ? attemptStateLabel(state) : jobStateLabel(state)}
        />
    );
}
